import {appNotificationsActions} from "./reducers";

export const GET_DATA_ABOUT_TOKEN: string = "GET_DATA_ABOUT_TOKEN";
export const GET_TOPICS_SUBSCRIBED: string = "GET_TOPICS_SUBSCRIBED";
export const VERIFICATION_TOKEN: string = "VERIFICATION_TOKEN";

export const SET_LOADING_DATA_ABOUT_TOKEN: string = appNotificationsActions.setLoadingDataAboutToken.type;
export const SET_LOADING_TOPIC_SUBSCRIBED: string = appNotificationsActions.setLoadingTopicsSubscribed.type;
export const SET_TOKEN_EXIST_STATUS: string = appNotificationsActions.setTokenExistStatus.type;
